import * as React from 'react';

export const PlayIcon = ({ className }: { className?: string }) => (
  <svg width="40" height="40" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path
      d="M15.9998 2.66663C8.63984 2.66663 2.6665 8.63996 2.6665 16C2.6665 23.36 8.63984 29.3333 15.9998 29.3333C23.3598 29.3333 29.3332 23.36 29.3332 16C29.3332 8.63996 23.3598 2.66663 15.9998 2.66663ZM13.3332 22V9.99996L21.3332 16L13.3332 22Z"
      fill="currentColor"
    />
  </svg>
);
